
import { Link } from 'react-router-dom'
import { 
  LayoutDashboard, 
  FileText, 
  Move,
  Plane,
  CreditCard,
  BarChart3,
  ArrowRight
} from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from '@/components/ui/card'

const demos = [
  {
    title: "Ops Dashboard Mock",
    path: "/ops-dashboard",
    description: "Hybrid layout for daily operations with horizontal alerts, split schedule, and timeline views.",
    icon: Plane,
    color: "text-blue-600 bg-blue-50"
  },
  {
    title: "Dashboard MVP Mock",
    path: "/dashboard-mvp",
    description: "Capacity Command Center with high-level stats, occupancy breakdown, and schematics.",
    icon: LayoutDashboard,
    color: "text-emerald-600 bg-emerald-50"
  },
  {
    title: "Space Revenue Report",
    path: "/reports/space-revenue",
    description: "Detailed report on hangar space utilization and revenue generation.",
    icon: FileText,
    color: "text-amber-600 bg-amber-50"
  },
  {
    title: "Space Yield Report (v3.3)",
    path: "/demo/space-yield",
    description: "Unified yield report combining Lease and Transient revenue into a single 'Yield/Sqft' view.",
    icon: FileText,
    color: "text-indigo-600 bg-indigo-50"
  },
  {
    title: "Building Metrics Variations",
    path: "/demo/building-metrics-variations",
    description: "Exploration of visual approaches for comparing Revenue, Occupancy, and Yield.",
    icon: BarChart3,
    color: "text-emerald-600 bg-emerald-50"
  },
  {
    title: "Card Header Variations",
    path: "/demo/card-headers",
    description: "Exploration of different card header designs and action buttons.",
    icon: CreditCard,
    color: "text-purple-600 bg-purple-50"
  },
   {
    title: "Card Header Refined",
    path: "/demo/card-headers-refined",
    description: "Refined card header designs with improved UX for quick actions.",
    icon: CreditCard,
    color: "text-pink-600 bg-pink-50"
  },
  {
    title: "Movement Timeline",
    path: "/demo/movement-timeline",
    description: "Highly polished Tri-View Architecture (Enhanced List, Vertical Day Flow, and Gantt Timeline) for aircraft ground operations.",
    icon: Move,
    color: "text-orange-600 bg-orange-50"
  },
  {
    title: "5D Hangar Planner",
    path: "/demo/5d-planner",
    description: "Interactive Hangar Intelligence sales demo — scripted 3D aircraft stacking optimization with ROI metrics. Wizard of Oz approach for investor & FBO pitches.",
    icon: Plane,
    color: "text-cyan-600 bg-cyan-50"
  },
  {
    title: "Drag & Drop Test",
    path: "/demo/drag-test",
    description: "Prototype for drag-and-drop interactions within the FBO interface.",
    icon: Move,
    color: "text-slate-600 bg-slate-50"
  },
  {
    title: "Select or Add New UX",
    path: "/demo/select-or-add-new",
    description: "3 mock variations for selecting an existing item or creating a new one inline.",
    icon: FileText,
    color: "text-blue-600 bg-blue-50"
  }
]

export function DemoIndexPage() {
  return (
    <div className="min-h-screen bg-slate-50/50 p-8">
      <div className="max-w-5xl mx-auto space-y-8">
        
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight text-slate-900">Component Demos</h1>
          <p className="text-lg text-slate-600">
            Showcase of UI components, page layouts, and prototypes for PlaneMAX.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {demos.map((demo) => (
            <Link key={demo.path} to={demo.path} className="group block h-full">
              <Card className="h-full transition-all duration-200 hover:shadow-lg hover:border-slate-300 border-slate-200">
                <CardHeader>
                  <div className="flex items-start justify-between">
                    <div className={`p-3 rounded-xl ${demo.color}`}>
                      <demo.icon className="w-6 h-6" />
                    </div>
                    <ArrowRight className="w-5 h-5 text-slate-300 group-hover:text-slate-600 transition-colors" />
                  </div>
                  <CardTitle className="mt-4 text-xl group-hover:text-blue-600 transition-colors">
                    {demo.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base">
                    {demo.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

      </div>
    </div>
  )
}
